import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchCampaign } from '../api/api';

const CampaignDetail = ({ setAlert }) => {
  const { name } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchCampaign(name);
        setCampaign(res);
      } catch (err) {
        console.error('Failed to load queue', err);
        setError('Failed to load queue.');
        setAlert?.({ variant: 'error', heading: 'Error', text: 'Failed to load queue.' });
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [name, setAlert]);

  if (loading) {
    return <div className="text-center mt-20 text-gray-500">Loading...</div>;
  }

  if (error) {
    return <div className="text-center mt-20 text-red-500">{error}</div>;
  }

  if (!campaign) {
    return <div className="text-center mt-20 text-gray-500">Queue not found.</div>;
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">{campaign.campaignName}</h1>
        <div className="space-x-2">
          <button onClick={() => navigate('/campaigns')} className="btn-outline">Back</button>
          <button
            onClick={() => navigate(`/campaigns/${encodeURIComponent(campaign.campaignName)}`)}
            className="btn-primary"
          >
            Edit
          </button>
        </div>
      </div>
      <div className="card space-y-4">
        {campaign.version && (
          <p className="text-gray-700">Version: {campaign.version}</p>
        )}
        {campaign.createdAt && (
          <p className="text-gray-700">Created: {new Date(campaign.createdAt).toLocaleString()}</p>
        )}
        {campaign.updatedAt && (
          <p className="text-gray-700">Updated: {new Date(campaign.updatedAt).toLocaleString()}</p>
        )}
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Scorecards</h2>
          {campaign.templates && campaign.templates.length > 0 ? (
            <ul className="list-disc list-inside space-y-1">
              {campaign.templates.map(t => (
                <li key={t}>
                  <button
                    onClick={() => navigate(`/templates/${encodeURIComponent(t)}`)}
                    className="text-cyan-600 hover:underline"
                  >
                    {t}
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No scorecards linked.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CampaignDetail;
